import { render, staticRenderFns } from "./SessionReviewsComponent.vue?vue&type=template&id=af9a05c2"
import script from "./SessionReviewsComponent.vue?vue&type=script&lang=js"
export * from "./SessionReviewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports